export default __webpack_public_path__ + "static/poynt-5-smart-terminal-620687114bf5176472ee990c68ba3cc8.png";